<p-drawer
  [(visible)]="studentScheduleOpen"
  position="right"
  styleClass="student-schedule-sidebar"
  [showCloseIcon]="true">
  <ng-template #header>
    <h4 class="title-small-bold text-primary-color">Student Schedule</h4>
  </ng-template>
  <app-student-schedule
    [studentSchedule]="studentSchedule"
    [avatarUrl]="avatarUrl"></app-student-schedule>
</p-drawer>

<div class="nav-sm px-spacing-3xl py-spacing-md bg-white gap-spacing-3xl align-items-center justify-content-between">
  <app-button
    (btnClick)="back()"
    class="ride-details-back-btn"
    iconStart="icon-caret-left"
    sizeClass="p-button-sm"
    severity="primary"
    label="Back"
    [textButton]="true"></app-button>

  <div class="flex gap-spacing-xl align-items-center">
    <app-button
      iconStart="icon-map-trifold"
      (btnClick)="openMapDialog()"
      sizeClass="p-button-sm"
      severity="primary"
      label="Map"
      [outlinedButton]="true"></app-button>
    <app-button
      (btnClick)="openActionsDialog()"
      class="block md:hidden"
      [iconOnlyButton]="true"
      icon="icon-dots-three-vertical"
      sizeClass="p-button-sm"
      severity="primary"
      [outlinedButton]="true"></app-button>
  </div>
</div>

@if (currentRide() && currentRide().id) {
  <div class="grid grid-nogutter">
    <div class="list-column col-4 py-spacing-2xl soft-bg">
      <section class="list">
        <app-ride-list-item
          [activeRideId]="currentRide()!.id"
          view="ride-details"></app-ride-list-item>
      </section>
    </div>
    <div class="details-column col-5 px-spacing-xl py-spacing-2xl soft-bg">
      <section class="ride-details h-full">
        <div class="main-card border-round-lg flex flex-column bg-white border-1 border-neutral-base-primary-border">
          <div class="header px-spacing-xl py-spacing-md flex justify-content-between align-items-center gap-spacing-xs border-bottom-1 border-neutral-base-primary-border">
            <h5 class="mb-0 label-large-bold text-primary-color uppercase">Ride Details</h5>
            <app-tag
              styleClass="bold"
              [content]="currentRide()!.rideStatus || ''"
              sizeClass="tag-sm"
              [severityClass]="currentRide()!.rideStatus == 'Driver not Assigned' && isClient ? 'secondary' : currentRide()!.rideStatusSeverity || 'info'"></app-tag>
          </div>
          <div class="body px-spacing-xl">
            <div class="details py-spacing-md">
              <div class="details-card border-1 border-round-lg overflow-hidden border-neutral-base-primary-border">
                <div class="item-row grid grid-nogutter">
                  @if (!isClient) {
                    <div class="item col-12 md:col-6">
                      <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Ride ID</div>
                      <div class="item-body py-spacing-xs px-spacing-3xl">
                        {{ currentRide()!.id }}
                      </div>
                    </div>
                  }
                  <div
                    class="item"
                    [ngClass]="!isClient ? 'col-12 md:col-6' : 'col-12'">
                    <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Time</div>
                    <div class="item-body py-spacing-xs px-spacing-3xl">
                      <div class="flex flex-column">
                        <span>{{ currentRide()!.rideTime.from }} - {{ currentRide()!.rideTime.to }}</span>
                        <span class="text-caption-muted">{{ currentRide()!.rideTime.utcTimezoneDiff }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-row grid grid-nogutter">
                  <div class="item col-12 md:col-6">
                    <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Ride Type</div>
                    <div class="item-body py-spacing-xs px-spacing-3xl">
                      <div class="flex flex-column">
                        <span>{{ currentRide()!.rideInfo.type }}</span>
                        @if (currentRide()!.rideInfo.type) {
                          <span class="text-caption-muted">
                            {{ currentRide()!.rideInfo.type.toLowerCase() == rideType().outbound ? "Home to School" : "School to Home" }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="item col-12 md:col-6">
                    <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Car</div>
                    <div class="item-body py-spacing-xs px-spacing-3xl">
                      <div class="flex gap-spacing-md align-items-center">
                        <p-avatar
                          class="border-round-md overflow-hidden border-1 form-border-brand-active-border"
                          image="assets/images/car.PNG"
                          size="large" />
                        <div class="flex flex-column">
                          <span>{{ currentRide()!.driverDetails?.blueprintCarType }}</span>
                          <span class="text-caption-muted">
                            <!-- Wheelchair or Sedan = 4 seats. Large Vehicle = 6 seats -->
                            {{ currentRide()!.driverDetails?.blueprintCarType?.toLowerCase() == "large vehicle" ? 6 : 4 }}
                            Seats
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-row grid grid-nogutter">
                  <div class="item col-12 md:col-6">
                    <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Contractor</div>
                    <div class="item-body py-spacing-xs px-spacing-3xl">
                      <div class="flex gap-spacing-md align-items-center">
                        <p-avatar
                          class="blue-light relative"
                          [label]="(currentRide()!.driverDetails?.name)![0]"
                          size="large">
                          <span
                            [ngClass]="{ active: driverAvailability() || false }"
                            class="avatar-status"></span>
                        </p-avatar>
                        <div class="flex flex-column">
                          <span>{{ currentRide()!.driverDetails?.name }}</span>
                          @if (currentRide()!.driverDetails?.number != "108179") {
                            <a
                              (click)="openContractorDialog()"
                              class="text-link-color cursor-pointer no-underline"
                              >#{{ currentRide()!.driverDetails?.number }}</a
                            >
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item col-12 md:col-6">
                    <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Blueprint</div>
                    <div class="item-body py-spacing-xs px-spacing-3xl">
                      <div class="flex gap-spacing-md align-items-center">
                        <p-avatar
                          class="blue-lighter overflow-hidden border-1 border-round-md form-border-brand-active-border"
                          icon="icon-blueprint"
                          size="large" />
                        <div class="flex flex-column">
                          <ul class="pl-spacing-xl m-0">
                            @for (client of currentRide()!.clientDetails; track $index) {
                              <li>
                                <span style="margin-left: -0.25rem">{{ client.name }}</span>
                              </li>
                            }
                          </ul>
                          <a
                            (click)="openBlueprintDialog()"
                            class="text-link-color cursor-pointer no-underline"
                            >#{{ currentRide()!.blueprintId }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (appSetting.hasCameraIconPermission) {
                    <div class="item col-12">
                      <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-top-1 border-neutral-base-primary-border">Camera</div>
                      <div class="item-body py-spacing-md px-spacing-3xl">
                        <div class="camera-tags flex align-items-center">
                          @if (currentRide()!.driverDetails?.id == partnerBotId()) {
                            <app-tag
                              styleClass="bold"
                              [content]="currentRide()!.isCameraRequired ? 'Required' : 'Not Required'"
                              sizeClass="tag-sm"
                              [severityClass]="'info'"
                              [iconStart]="currentRide()!.isCameraRequired ? 'icon-video-camera-solid' : 'icon-video-camera-slash-solid'">
                            </app-tag>
                          } @else {
                            @if (currentRide()!.isCameraRequired && currentRide()!.driverDetails?.id !== partnerBotId()) {
                              @if (cameraId()) {
                                <app-tag
                                  [ngClass]="{ 'cursor-pointer': isCameraDialogEnabled() }"
                                  styleClass="bold"
                                  [content]="cameraOnlineStatus() ? 'Required - On' : 'Required - Off'"
                                  sizeClass="tag-sm"
                                  [severityClass]="cameraOnlineStatus() ? 'success' : 'danger'"
                                  [pTooltip]="(cameraOnlineStatus() ? 'Active' : 'Offline') + (lastSyncDate() ? ' - Last Sync ' + (lastSyncDate()! | date: 'h:mm a') : '')"
                                  [tooltipOptions]="tooltipOptions"
                                  [iconStart]="'icon-video-camera-solid'"
                                  (tagClick)="isCameraDialogEnabled() ? openCameraDialog() : null">
                                </app-tag>
                              } @else {
                                <app-tag
                                  styleClass="bold"
                                  [content]="'Required - Not Installed'"
                                  sizeClass="tag-sm"
                                  [severityClass]="'secondary'"
                                  [pTooltip]="'Required - Not Installed'"
                                  [tooltipOptions]="tooltipOptions"
                                  [iconStart]="'icon-video-camera-slash-solid'"></app-tag>
                              }
                            } @else {
                              <app-tag
                                styleClass="bold"
                                [content]="'Not Required'"
                                sizeClass="tag-sm"
                                [severityClass]="'info'"
                                [iconStart]="'icon-video-camera-slash-solid'">
                              </app-tag>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="more-info pt-spacing-md">
              <app-tabs [initialTabIndex]="0">
                <app-tab tabTitle="Stops">
                  <p-accordion
                    class="w-full"
                    (valueChange)="accordionActiveIndexChange($event)"
                    [value]="accordionActiveIndex">
                    @for (stop of currentRide()!.rideTimeline; let i = $index; track $index) {
                      <p-accordion-panel
                        [value]="i"
                        class="p-accordion-tab-element">
                        <p-accordion-header>
                          <div
                            class="relative header-wrapper w-full"
                            (click)="$event.stopPropagation()"
                            (keydown.enter)="$event.stopPropagation()">
                            <div
                              #headerRef
                              [ngClass]="{ open: accordionActiveIndex == i, done: stop.statusType == 'Visited' }"
                              class="stop w-full active flex justify-content-between gap-spacing-xs align-items-start">
                              <div class="left flex gap-spacing-md align-items-center">
                                <div class="badge-container relative">
                                  <app-badge
                                    [pTooltip]="stop.active || (isClient && stop.statusType?.toLowerCase() === 'visited') ? tooltipContent : ''"
                                    tooltipPosition="bottom"
                                    [autoHide]="false"
                                    [value]="(i + 1).toString()"
                                    size="xlarge"
                                    [severityClass]="stop.attentionColor"></app-badge>
                                  <span class="h-line"></span>

                                  <ng-template #tooltipContent>
                                    <app-ride-timeline-tooltip [stop]="stop"></app-ride-timeline-tooltip>
                                  </ng-template>
                                </div>
                                <span class="time text-base font-medium text-secondary-color">{{ stop.time }}</span>
                                <span class="passengers-number text-base font-medium"> <i class="icon-users-solid"></i> {{ stop.cargoes?.length }} </span>
                              </div>

                              <div class="right gap-spacing-4xl flex justify-content-between align-items-center">
                                @if (stop.statusType) {
                                  <app-tag
                                    styleClass="bold"
                                    [content]="isClient ? (stop.statusType.toLowerCase() == 'enroute' ? 'In Progress' : stop.statusType) : stop.statusType"
                                    sizeClass="tag-sm"
                                    [severityClass]="stop.attentionColor"></app-tag>
                                }
                                <div class="action-btns flex gap-spacing-xs align-items-center">
                                  <div>
                                    <app-button
                                      (btnClick)="setRideStopMenuItems($event, stop, rideStopMenu, i)"
                                      [iconOnlyButton]="true"
                                      icon="icon-list"
                                      sizeClass="p-button-sm"
                                      severity="primary"
                                      [outlinedButton]="true"></app-button>
                                    <p-menu
                                      styleClass="ride-stop-menu"
                                      [appendTo]="'body'"
                                      [autoZIndex]="true"
                                      #rideStopMenu
                                      [model]="rideStopMenuItems()"
                                      [popup]="true" />
                                  </div>
                                  <app-button
                                    [ngClass]="{ 'accordion-btn-active': accordionActiveIndex == i }"
                                    (btnClick)="toggleActiveAccordionTab(i)"
                                    [iconOnlyButton]="true"
                                    [icon]="accordionActiveIndex == i ? 'icon-caret-up' : 'icon-caret-down'"
                                    sizeClass="p-button-sm"
                                    severity="primary"
                                    [outlinedButton]="true"></app-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </p-accordion-header>

                        <p-accordion-content>
                          <div class="content relative flex flex-column gap-spacing-md">
                            <span class="h-line"></span>
                            <div class="location px-spacing-md">
                              <div class="place flex align-items-center gap-spacing-xs">
                                @if (stop.placeType == stopPlaceType().School) {
                                  <i class="icon-building-office-solid text-base text-lightest-color"></i>
                                } @else {
                                  <img
                                    src="assets/images/house-5 1.svg"
                                    alt="" />
                                }
                                <span class="name text-base font-medium text-primary-color">{{ stop.place }}</span>
                              </div>
                              <div class="map-location flex align-items-center gap-spacing-xs">
                                <i class="icon-map-pin-solid text-base text-link-color"></i>
                                <a class="link no-underline text-base font-normal text-link-color">{{ stop.address }}</a>
                              </div>
                            </div>

                            <div class="passengers flex flex-column gap-spacing-md pb-spacing-xl">
                              @for (passenger of stop.cargoes; track $index) {
                                <div
                                  #passengerRef
                                  class="passenger px-spacing-md py-spacing-xs bg-white flex justify-content-between gap-spacing-xs border-round-md shadow-1">
                                  <div class="left flex align-items-center gap-spacing-xs">
                                    <div class="flex align-items-center gap-spacing-xs">
                                      @if (passenger.actionType.toLowerCase() == cargoActionType().PickUp.toLowerCase()) {
                                        <img
                                          src="assets/images/person-plus-fill 1.svg"
                                          alt="" />
                                      } @else if (passenger.actionType.toLowerCase() == cargoActionType().DropOff.toLowerCase()) {
                                        <img
                                          src="assets/images/person-dash-fill 1.svg"
                                          alt="" />
                                      }
                                      <span class="name text-base font-medium line-height-3 text-primary-color">
                                        {{ passenger.name }}
                                      </span>
                                    </div>
                                    <span class="text-sm form-border-hover-color px-spacing-default border-1 form-border-default-border line-height-2 border-round">
                                      {{ passenger.type }}
                                    </span>
                                    @if (passenger.type == passengerType().Student) {
                                      <button
                                        class="icon-link-color text-inverse-bg border-1 icon-link-border radius-default p-spacing-3xs"
                                        (click)="viewStudentSchedule(passenger)">
                                        <i class="icon-calendar-dots size-icon-sm"></i>
                                      </button>
                                    }
                                  </div>

                                  <div class="right gap-spacing-4xl flex justify-content-between align-items-center">
                                    <app-tag
                                      [content]="passenger.status"
                                      sizeClass="tag-sm"
                                      severityClass="secondary">
                                    </app-tag>
                                    @if ((passenger.type == passengerType().Monitor && currentRide()!.JobStatusId == rideStatusType.InProgress) || passenger.type == passengerType().Student) {
                                      <div>
                                        @if (hasCancelTransportationPermission || hasChangeStopCargoStatus) {
                                          <app-button
                                            (click)="setPassengerMenu($event, stop, passenger, passengerMenu)"
                                            (keydown.enter)="setPassengerMenu($event, stop, passenger, passengerMenu)"
                                            [iconOnlyButton]="true"
                                            icon="icon-dots-three-vertical"
                                            sizeClass="p-button-sm"
                                            severity="primary"
                                            [textButton]="true"></app-button>
                                        }
                                        <p-menu
                                          [appendTo]="'body'"
                                          [autoZIndex]="true"
                                          styleClass="passenger-menu"
                                          #passengerMenu
                                          [model]="passengerMenuItems()"
                                          [popup]="true" />
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </p-accordion-content>
                      </p-accordion-panel>
                    }
                  </p-accordion>
                </app-tab>
              </app-tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="actions-column col-3 pe-4 py-spacing-2xl pr-spacing-xl soft-bg">
      <div class="actions-container flex flex-column gap-spacing-xl">
        <section class="map">
          <div class="main-card h-full border-round-lg flex flex-column bg-white border-1 border-neutral-base-primary-border">
            <div class="header px-spacing-xl py-spacing-xs flex justify-content-between align-items-center gap-spacing-xs">
              <h5 class="mb-0 label-large-bold uppercase text-primary-color">Map</h5>
              <app-button
                (btnClick)="openMapDialog()"
                [iconOnlyButton]="true"
                icon="icon-list"
                sizeClass="p-button-sm"
                severity="primary"
                [outlinedButton]="true"></app-button>
            </div>
            <div class="body h-full">
              <div class="map-card">
                <app-ride-details-map-pro
                  #inlineRideMap
                  [rideStops]="currentRide()!.rideTimeline"
                  [rideId]="currentRide()!.dispatchId"
                  [rideDOT]="currentRide()!.rideInfo.strDateOfService"
                  [enableLiveTracking]="currentRide()!.enableLiveTracking"
                  [timezoneOffsetInSeconds]="currentRide()!.timezoneOffsetInSeconds">
                </app-ride-details-map-pro>
              </div>
            </div>
          </div>
        </section>

        <section class="actions">
          <div class="main-card border-round-lg flex flex-column bg-white border-1 border-neutral-base-primary-border">
            <div class="header px-spacing-xl py-spacing-xs flex justify-content-between align-items-center gap-spacing-xs border-bottom-1 border-neutral-base-primary-border">
              <h5 class="mb-0 text-base uppercase font-semibold line-height-3">Actions</h5>
            </div>
            <app-ride-actions
              [favoriteActions]="favoriteActions"
              [rideActionsMap]="rideActionsMap"
              [actionsMenuItems_1]="actionsMenuItems_1"
              [actionsMenuItems_2]="actionsMenuItems_2"
              [actionsMenuItems_3]="actionsMenuItems_3"></app-ride-actions>
          </div>
        </section>
      </div>
    </div>
  </div>
}
